import React, { Component } from 'react';
import { Container } from 'reactstrap';

export class Layout extends Component {
  static displayName = Layout.name;
   
    render() {
        function getParameterByName(name, url = window.location.href) {
            name = name.replace(/[\[\]]/g, '\\$&');
            var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, ' '));
        }
        var cultureCode = getParameterByName('cc');
   
      return (
          <div>
                 <div id="backwardsC" className="leftSide">

                                       {/*<img className="dfImage loginImage" alt="Dayforce Logo" src="/StaticFiles/images/DFLogo.svg" />*/}
                      {cultureCode == 'fr-CA' ?
                      <img className="dfImage loginImage" alt="Dayforce Logo" src="/StaticFiles/images/DayforceMainLogo_Fr.png" />
                     :
                      <img className="dfImage loginImage" alt="Dayforce Logo" src="/StaticFiles/images/DayforceMainLogo.png" />
                      }
          
              </div>
              <div className="rightSide" style={{position: 'relative'}}>
                <Container style={{height:"100vh"}}>
                  {this.props.children}
                </Container>
           
           </div>
        </div>
    );
  }
}
